var _a;
import { __decorate, __metadata, __param } from "tslib";
import { I18nService } from '@/services/i18n-service';
import { inject, injectable } from 'inversify';
let FieldPermissionActionContribution = class FieldPermissionActionContribution {
    constructor(_i18nService) {
        this._i18nService = _i18nService;
    }
    registerCustomFieldActions(action) {
        action.registerCustomFieldAction({
            commandId: 'custom-field.permission-setting',
            icon: 'SolidSettings',
            label: this._i18nService.t('customField.actions.advancedPermissionSetting'),
            order: 4,
            isEnabled: (context) => {
                // 只有企业管理员可以设置权限，且必须选择单个字段
                return context.fields.length === 1 &&
                    context.isAdmin &&
                    this._isEnterpriseField(context);
            },
            isVisible: (context) => {
                // 只对企业自定义字段显示，且只能选择单个字段
                return context.fields.length === 1 &&
                    context.isAdmin &&
                    this._isEnterpriseField(context);
            },
        });
    }
    _isEnterpriseField(context) {
        // 判断是否为企业字段，根据isPublicMode判断
        // isPublicMode为true表示当前在企业字段模式
        return context.isPublicMode;
    }
};
FieldPermissionActionContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object])
], FieldPermissionActionContribution);
export { FieldPermissionActionContribution };
